module.exports = __webpack_public_path__ + "static/Slider3-562b80decd133200f720109481a45f08.jpg";